import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

/** Path only (no query or hash). Inertia's `usePage().url` includes query strings. */
export function inertiaUrlPathname(url) {
  if (!url) return ""
  return url.split(/[?#]/)[0]
}

/** `tab` value from a path-or-full URL that may include `?tab=…` (e.g. coach Content subtabs). */
export function inertiaUrlTab(url) {
  if (!url) return null
  const q = url.split("?")[1]?.split("#")[0]
  if (!q) return null
  return new URLSearchParams(q).get("tab")
}
